import { loadSettings, saveSettings } from '@/config/localSettings';
import { type ComponentSizeType } from '@contiple/antd-ds';
import { create } from 'zustand';

interface ComponentSizeState {
  componentSize: ComponentSizeType;
  setComponentSize: (componentSize: ComponentSizeType) => void;
}

export const useComponentSizeStore = create<ComponentSizeState>((set) => ({
  componentSize: loadSettings().componentSize,
  setComponentSize: (componentSize) => {
    set({ componentSize });
    saveSettings({ componentSize });
  },
}));
